
import './Spinner.scss';

export const Spinner = () => {
  return (
    <div className="spinner"></div>
  )
}
